module["exports"] = ["box.az", "mail.az", "gmail.com", "yahoo.com", "hotmail.com"];